import React from "react";
import { config, Env } from "core/utils";
import { showNav, hideFooter } from "pages/program/Nav";
export var prepRoute = function (View, controller) { return ({
    match: function (type) {
        return type === "Program";
    },
    page: function (_a) {
        var data = _a.data;
        var program = data;
        if (program.vtmgoRedirectEnabled) {
            var title = program.title, uuid = program.uuid;
            var vtmGoUrl = config.urls.vtmgoOnDemand(title, uuid);
            if (Env.isClient) {
                window.location.replace(vtmGoUrl);
            }
            controller.setRedirectUrl(vtmGoUrl);
            return null;
        }
        return React.createElement(View, { program: program });
    },
    showNav: showNav,
    hideFooter: hideFooter,
}); };
